import { useRemoveNoteTabMutation } from 'src/modules/exam-preparation/graphql/noteTabs/remove';
export default function useData(noteID, noteTab) {
    const [removeNoteTabMutationState, removeNoteTabMutationActions] = useRemoveNoteTabMutation();
    const deleteTab = async () => {
        await removeNoteTabMutationActions.submit({
            variables: {
                noteTabID: noteTab.id,
            },
            context: {
                noteID,
            },
        });
    };
    const state = {
        removeNoteTabMutation: removeNoteTabMutationState,
    };
    const actions = {
        deleteTab,
    };
    return [state, actions];
}
